/* eslint-disable no-lone-blocks */
import React from "react";
import bg_team from "../../assets/images/our-team-bg.png";
import dr_img_1 from "../../assets/images/our-Team-1.jpg";
import dr_img_2 from "../../assets/images/Our-team.jpg";
import dr_img_3 from "../../assets/images/out-team-4.jpg";
import dr_img_4 from "../../assets/images/our-team3.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
const HomePageTeam = () => {
  const data = [
    {
      name: "Seeing Patients",
      image: dr_img_1,
      position: "Gynocologist",
    },
    {
      name: "Seeing Patients",
      image: dr_img_2,
      position: "Gynocologist",
    },
    {
      name: "Seeing Patients",
      image: dr_img_3,
      position: "Gynocologist",
    },
    {
      name: "Seeing Patients",
      image: dr_img_4,
      position: "Gynocologist",
    },
    {
      name: "Seeing Patients",
      image: dr_img_1,
      position: "Gynocologist",
    },
    {
      name: "Seeing Patients",
      image: dr_img_2,
      position: "Gynocologist",
    },
    {
      name: "Seeing Patients",
      image: dr_img_3,
      position: "Gynocologist",
    },
    {
      name: "Seeing Patients",
      image: dr_img_4,
      position: "Gynocologist",
    },
    {
      name: "Seeing Patients",
      image: dr_img_1,
      position: "Gynocologist",
    },
    {
      name: "Seeing Patients",
      image: dr_img_2,
      position: "Gynocologist",
    },
    {
      name: "Seeing Patients",
      image: dr_img_3,
      position: "Gynocologist",
    },
    {
      name: "Seeing Patients",
      image: dr_img_4,
      position: "Gynocologist",
    },
  ];

  return (
    <div
      className="flex flex-col items-center py-28 px-4"
      style={{
        backgroundImage: `url(${bg_team})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "#F6F9FF",
      }}
    >
      <div className="text-[#243FFA] text-[16px] text-center font-normal font-outfit">
        OUR TEAM
      </div>
      <h2 className="xl:text-[52px] text-[32px] font-outfit text-center font-semibold text-[#0F2349]">
        Meet Our Professional Team
      </h2>

      <div className="w-full max-w-screen-xl mt-12">
        <Swiper
          spaceBetween={10}
          loop={true}
          grabCursor={true}
          centeredSlides={false} // important when showing 4 cards
          breakpoints={{
            320: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
          }}
          className="w-full"
        >
          {data.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="flex flex-col justify-center items-center pt-10 pb-6 px-4 rounded-xl">
                <figure className="w-[250px] h-[250px] group mb-6 rounded-full overflow-hidden shadow-md ">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover transition-all duration-300 group-hover:brightness-90 group-hover:contrast-110"
                  />
                </figure>
                <h5 className="text-[#0F2349] text-[22px] font-semibold font-outfit text-center">
                  {item.name}
                </h5>
                <p className="text-[#757887] text-[16px] font-outfit font-normal text-center mt-2">
                  {item.position}
                </p>
                <div className="flex justify-center flex-row gap-6 items-center my-6">
                  <a
                    href="/" aria-label="facebook"
                    className="flex justify-center items-center w-10 h-10 rounded-full bg-blue-600 text-white border-[1px] border-blue-600 hover:bg-white hover:text-blue-600 transition-all hover:-translate-y-1  hover:duration-300 group"
                  >
                    <FacebookOutlinedIcon className="" />
                  </a>
                  <a
                    href="/" aria-label="instagram"
                    className="flex justify-center items-center w-10 h-10 rounded-full bg-blue-600 text-white border-[1px] border-blue-600 hover:bg-white hover:text-blue-600 transition-all hover:-translate-y-1  hover:duration-300 group"
                  >
                    <XIcon />
                  </a>
                  <a aria-label="linkedin"
                    href="/"
                    className="flex justify-center items-center w-10 h-10 rounded-full bg-blue-600 text-white border-[1px] border-blue-600 hover:bg-white hover:text-blue-600 transition-all hover:-translate-y-1  hover:duration-300 group"
                  >
                    <LinkedInIcon />
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default HomePageTeam;

